// REMINDER: DO NOT HARDCODE ANY RETURN/REDIRECT DOMAIN OR ADD FALLBACK REDIRECT URLS, THIS BREAKS THE AUTH
// Shared Google OAuth entry point — the ONLY place that builds the authorization
// redirect. /login (LoginPage.js), /signup (SignupPage.js) and the Dashboard guest
// conversion modal all use this same flow.
const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';
// Public by design (an OAuth client_id is not a secret). Hardcoded so the flow never
// depends on build-time env vars — same criterion as API_BASE in lib/api.js.
const GOOGLE_CLIENT_ID = '127760136081-kac9d7vcq6jg8mrtfdetp5ug5go9rao7.apps.googleusercontent.com';

export function redirectToGoogleLogin() {
  const redirectUri = window.location.origin + '/auth/google/callback';
  // Anti-CSRF state: random hex, stored for single use — AuthCallback compares it
  // against the value Google echoes back and deletes it after reading.
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  const state = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  sessionStorage.setItem('google_oauth_state', state);
  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'openid email profile',
    state,
  });
  window.location.href = `${GOOGLE_AUTH_URL}?${params.toString()}`;
}
